import React, { useState } from 'react';
import { BellIcon, XIcon } from 'lucide-react';
import { Card } from './Card';
export function NotificationBell() {
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([{
    id: 1,
    message: 'Your expense at Starbucks has been approved',
    read: false,
    timestamp: '10 minutes ago'
  }, {
    id: 2,
    message: 'New company expense policy update',
    read: false,
    timestamp: '2 hours ago'
  }, {
    id: 3,
    message: 'Your per diem has been refreshed',
    read: true,
    timestamp: 'Yesterday'
  }]);
  const unreadCount = notifications.filter(n => !n.read).length;
  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
    if (!showNotifications && unreadCount > 0) {
      // Mark all as read when opening
      setNotifications(notifications.map(n => ({
        ...n,
        read: true
      })));
    }
  };
  const removeNotification = id => {
    setNotifications(notifications.filter(n => n.id !== id));
  };
  return <div className="relative" data-id="element-60">
      <button onClick={toggleNotifications} className="p-2 hover:bg-gray-100 rounded-full transition-colors relative" aria-label={`Notifications ${unreadCount > 0 ? `(${unreadCount} unread)` : ''}`} data-id="element-61">
        <BellIcon size={20} className="text-gray-500" data-id="element-62" />
        {unreadCount > 0 && <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center" data-id="element-63">
            {unreadCount}
          </span>}
      </button>
      {showNotifications && <div className="absolute right-0 mt-2 w-80 z-50" data-id="element-64">
          <Card className="shadow-lg" data-id="element-65">
            <div className="flex justify-between items-center mb-2" data-id="element-66">
              <h3 className="font-bold" data-id="element-67">Notifications</h3>
              <button onClick={toggleNotifications} className="p-1 hover:bg-gray-100 rounded-full" aria-label="Close notifications" data-id="element-68">
                <XIcon size={16} className="text-gray-500" data-id="element-69" />
              </button>
            </div>
            {notifications.length > 0 ? <div className="max-h-80 overflow-y-auto" data-id="element-70">
                {notifications.map(notification => <div key={notification.id} className={`p-3 border-b last:border-b-0 ${notification.read ? '' : 'bg-blue-50'}`} data-id="element-71">
                    <div className="flex justify-between" data-id="element-72">
                      <p className="text-sm" data-id="element-73">{notification.message}</p>
                      <button onClick={e => {
                e.stopPropagation();
                removeNotification(notification.id);
              }} className="ml-2 text-gray-400 hover:text-gray-600" aria-label="Remove notification" data-id="element-74">
                        <XIcon size={14} data-id="element-75" />
                      </button>
                    </div>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-76">
                      {notification.timestamp}
                    </p>
                  </div>)}
              </div> : <div className="py-8 text-center text-gray-500" data-id="element-77">
                <p data-id="element-78">No notifications</p>
              </div>}
          </Card>
        </div>}
    </div>;
}